/*global moment*/
import { getTemplate } from "../template-helper";
import Inputmask from "inputmask";
import { locale } from "../../util/locales" ;
import { uuidv4 } from "../../util/utils";
import { runInContext } from "../binding.js";

const COMPONENT_NAME = "z-date" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class DateComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback(){
                this.init() ;
            }


            init(){

                if(!this.innerHTML){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                }

                let id = uuidv4() ;
                
                let input = this.querySelector("input") ;
                let inputGroup = this.querySelector(".input-group") ;
                let inputGroupPrepend = this.querySelector(".input-group-prepend") ;

                inputGroup.id = id ;
                inputGroupPrepend.setAttribute("data-target", "#"+id) ;
                input.setAttribute("data-target", "#"+id) ;

                let isDateOnly = true;
                let localeData = locale.date ;
                let localeDateFormat = localeData.defaultFormat ;
                let maskFormat = localeData.defaultFormat.toLowerCase() ;
                let type = this.getAttribute("z-type") ;
                if(["datetime"].indexOf(type) !== -1){
                    localeDateFormat = localeData.defaultFormat + " "+localeData.timeFormat ;
                    if(!localeData.timeFormat.toLowerCase().includes("hh")) {
                        maskFormat = localeData.defaultFormat.toLowerCase() + " " + (localeData.timeFormat.charAt(0) + localeData.timeFormat).replace("A", "TT").replace(/m/g, "M") ;
                    } else {
                        maskFormat = localeData.defaultFormat.toLowerCase() + " "+
                            localeData.timeFormat.replace("A", "TT").replace(/m/g, "M") ;
                    }
                    isDateOnly = false;
                }else if(type === "time"){
                    this.querySelector(".far").classList.remove("fa-calendar-alt") ;
                    this.querySelector(".far").classList.add("fa-clock") ;
                    localeDateFormat = localeData.timeFormat ;
                    if(!localeData.timeFormat.toLowerCase().includes("hh")) {
                        maskFormat = (localeData.timeFormat.charAt(0) + localeData.timeFormat).replace("A", "TT").replace(/m/g, "M") ;
                    } else {
                        maskFormat = localeData.timeFormat.replace("A", "TT").replace(/m/g, "M") ;
                    }
                    isDateOnly = false;
                }


                this.style.position = "relative" ;

                let pickerOptions = {
                    useCurrent: false,
                    // allowInputToggle: true,
                    // focusOnShow: true,
                    buttons: {
                        showToday: true,
                        showClear: true,
                        showClose: true
                    },
                    container: "#"+id,
                    format : localeDateFormat,
                    icons: {
                        time: 'far fa-clock',
                        date: 'far fa-calendar',
                        up: 'fas fa-arrow-up',
                        down: 'fas fa-arrow-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'far fa-calendar-check',
                        clear: 'fas fa-eraser',
                        close: 'fas fa-times'
                    }
                } ;
                if(window.innerWidth<1024){
                    pickerOptions.widgetParent = window.jQuery(window.document.body) ;
                    pickerOptions.ignoreReadonly = true;
                   /* input.setAttribute("z-never-readonly", "true") ;
                    input.setAttribute("readonly", "readonly") ;
                    input.readOnly = true;*/
                    input.inputMode = 'none' ;
                } 

                pickerOptions.locale = locale.lang ;

                let maskOptions = {
                    alias: "datetime", 
                    inputFormat: maskFormat, 
                    placeholder: "_",
                } ;

                let attrs = this.attributes ;
                for(let attr of attrs){
                    if(/^z-picker-option-/.test(attr.name) || /^z-mask-option-/.test(attr.name)){
                        let optName = attr.name
                            .replace(/^z-picker-option-/, "")
                            .replace(/^z-mask-option-/, "")
                            .split("-").map((v, i)=>{
                            if(i>0){
                                return v.substring(0,1).toUpperCase()+v.substring(1) ;
                            }else{
                                return v ;
                            }
                        }).join("") ;
                        let value = attr.value ;
                        if(value === "true"){ 
                            value = true ; 
                        }else if(value === "false"){ 
                            value = false ; 
                        }else if(value && 
                            (
                                (value[0] === "{" && value[value.length -1]=== "}") ||
                                (value[0] === "[" && value[value.length -1]=== "]") 
                            )){
                                try{
                                    value = JSON.parse(value) ;
                                }catch(e){
                                    console.error("WRONG VALUE "+value, e) ;
                                }
                        }
                        if(value.indexOf && value.indexOf("func:") === 0){
                            try{
                                value = runInContext(this, {}, value.replace("func:", "")) ;
                            }catch(err){
                                console.error("Error while running ", value, err);
                            }
                        }
                        const optPath = optName.split(".") ;
                        let optObject;
                        if(/^z-picker-option-/.test(attr.name)){
                            optObject = pickerOptions ;
                        }else{
                            optObject = maskOptions ;
                        }
                        while(optPath.length>1){
                            const p = optPath.shift() ;
                            if(!optObject[p]){
                                optObject[p] = {} ;
                            }
                            optObject = optObject[p] ;
                        }
                        optObject[optPath.shift()] = value ;
                    }
                }

                const im = new Inputmask(maskOptions);


                const $inputGroup = window.jQuery(inputGroup) ;
                $inputGroup.datetimepicker(pickerOptions);
                $inputGroup.on("change.datetimepicker", (e)=>{
                    if(this.ignoreNextChange){ 
                        //change came from set value, don't trigger change here
                        this.ignoreNextChange = false; 
                        return;
                    }
                    if(e.date){
                        this.dispatchEvent(new Event('change', {bubbles: true}));
                    }
                });
                if(window.innerWidth<1024){
                    $inputGroup.on("show.datetimepicker", ()=>{
                        $inputGroup.data("datetimepicker").widget.removeClass("bootstrap-datetimepicker-widget-readonly") ;
                    });
                } 

                input.onblur = function(){
                    setTimeout(()=>{
                        $inputGroup.datetimepicker("hide");
                    }, 200);
                };

                const parentAgCell = this.closest(".ag-cell") ;
                if(parentAgCell){
                    //is inside an ag-cell, must recompute the position
                    $inputGroup.data().datetimepicker._placeOrig = $inputGroup.data().datetimepicker._place.bind($inputGroup.data().datetimepicker) ;
                    $inputGroup.data().datetimepicker._place = (e)=>{ 
                        $inputGroup.data().datetimepicker._placeOrig(e) ;
                        const cellOffset = window.jQuery(parentAgCell).offset() ;
                        const widgetPosition = $inputGroup.data().datetimepicker.widget.position();
                        $inputGroup.data().datetimepicker.widget.css({
                            top: (cellOffset.top + widgetPosition.top)+"px",
                            left: (cellOffset.left + widgetPosition.left)+"px",
                        });
                    } ;
                }

                inputGroupPrepend.addEventListener("click", ()=>{
                    window.jQuery(inputGroup).datetimepicker("toggle");
                    window.jQuery(this).find(".bootstrap-datetimepicker-widget").css("box-sizing", "content-box");
                }) ;
                
                
                im.mask(input) ;
                input.inputmask.shadowRoot = input.getRootNode() ;

                input.onblur = function(){
                    setTimeout(()=>{
                        $inputGroup.datetimepicker("hide");
                    }, 10);
                };

                const button = this.querySelector("button") ;
                input.onclick = function() {
                    setTimeout(()=>{
                        if(!button.disabled){
                            $inputGroup.datetimepicker("toggle");
                        }
                    }, 20);
                };
                
                // input.addEventListener("change", (ev)=>{
                //     this.dispatchEvent(new Event('change', {bubbles: true}));
                // }) ;
                
                this.$inputGroup = $inputGroup;
                this.inputGroup = inputGroup ;
                this.input = input ;
                this.type = type ;

                this.isDateOnly = isDateOnly ;
                this.localeDateFormat = localeDateFormat;

                if(this.customValidity){
                    this.setCustomValidity(this.customValidity) ;
                }
                this.applyReadonly() ;
                this.applyRequired() ;
            }

            get value() {
                if(!this.input){ return null; }
                if(!this.input.value) { return null; }
                if(this.type === "time"){
                    return this.input.value ;
                }else{
                    if(!moment(this.input.value, this.localeDateFormat).isValid()) { return null; }
                    if(this.isDateOnly){
                        return moment.utc(this.input.value , this.localeDateFormat).format("YYYY-MM-DD") ;
                    }else{
                        return moment(this.input.value , this.localeDateFormat).utc().toISOString() ;
                    }
                }
            }
            
            set value(value) {
                if(value === 'now'){
                    value = new Date() ;
                }
                let date = value;
                if(value && /^\d{2}:\d{2}/.test(value)){
                    //is time only
                    date = moment("2000-01-01 "+value).toDate() ;
                }
                this.ignoreNextChange = true; //don't trigger next change event
                setTimeout(()=>{
                    this.ignoreNextChange = false;
                }, 100) ;
                window.jQuery(this.inputGroup).datetimepicker('date', date||null) ;
                if(this.input){
                    this.input.value = moment(date).format(this.localeDateFormat) ;
                }
            }

            static get observedAttributes() {
                return ['readonly', 'required'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'readonly':
                        this.applyReadonly();
                        break;
                    case 'required':
                        this.applyRequired();
                        break;
                }
            }

            applyReadonly(){
                const readonly = this.hasAttribute("readonly") ;

                const input = this.querySelector("input") ;
                const button = this.querySelector("button") ;
                if(input){
                    input.readOnly = readonly ;
                }
                if(button){
                    button.disabled = readonly ;
                }

                if(window.innerWidth<1024){
                    if(input){
                        //input.readOnly = true;
                    }
                } 



            }

            setCustomValidity(msg){
                this.customValidity = msg ;
                const input = this.querySelector("input") ;
                if(input){
                    input.setCustomValidity(msg) ;
                }
            }
    
            applyRequired(){
                const required = this.hasAttribute("required") ;

                const input = this.querySelector("input") ;
                if(input){
                    if(required){
                        input.setAttribute("required", "required") ;
                    }else{
                        input.removeAttribute("required") ;
                    }
                }
            }

            select(){
                if(this.$inputGroup){
                    this.$inputGroup.datetimepicker("toggle");
                }
                if(this.input && this.input.select){
                    this.input.select() ;
                }
            }
            checkValidity(){
                if(this.input && this.input.checkValidity){
                    return this.input.checkValidity() ;
                }
                return true;
            }
            focus(){
                if(this.input && this.input.focus){
                    this.input.focus() ;
                }
            }
        }
        customElements.define(COMPONENT_NAME, DateComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
